const Arrow = (props) => (
  <svg xmlns="http://www.w3.org/2000/svg" width="16" height="17" viewBox="0 0 16 17" fill="none" {...props}>
    <g clip-path="url(#clip0_62_24148)">
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M1.03576 15.6811C1.28121 15.927 1.60344 16.0499 1.92551 16.0499C2.24766 16.0499 2.56982 15.928 2.81566 15.6801L9.10922 9.38656C9.6009 8.89489 9.6009 8.09836 9.10922 7.60667L2.81566 1.3131C2.32397 0.821414 1.52744 0.821414 1.03576 1.3131C0.544071 1.80479 0.544071 2.60131 1.03576 3.093L6.44115 8.4976L1.03576 13.9012C0.544071 14.3929 0.544071 15.1894 1.03576 15.6811ZM6.69997 15.6811C6.94541 15.927 7.26764 16.0499 7.58973 16.0499C7.91186 16.0499 8.23402 15.928 8.47986 15.6801L14.7734 9.38656C15.2651 8.89489 15.2651 8.09836 14.7734 7.60667L8.47986 1.3131C7.98817 0.821414 7.19166 0.821414 6.69997 1.3131C6.20828 1.80479 6.20828 2.60131 6.69997 3.093L12.1053 8.4976L6.69997 13.9012C6.20828 14.3929 6.20828 15.1894 6.69997 15.6811Z"
        fill="white"
      />
    </g>
    <defs>
      <clipPath id="clip0_62_24148">
        <rect width="16" height="16" fill="white" transform="translate(0 0.5)" />
      </clipPath>
    </defs>
  </svg>
);

export default Arrow;
